import { IOption } from "Dashboard/domain/IOption";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { hrsService } from "../services/hrs.services";

const SalesUnitTypeSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const data = await hrsService.getSalesUnitTypes();
      const op = data.map((type) => {
        return {
          label: type.name,
          value: type.typeId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      if (props.options) {
        setOptions(props.options);
      } else {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.options]);

  useEffect(() => {
    if (props.defaultValue) {
      const values = options.filter((o) => o.value === props.defaultValue);
      if (values[0]) {
        setValue(values[0]);
      } else setValue(undefined);
    }
  }, [options, props.defaultValue]);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  return (
    <Select
      isClearable
      styles={props.customStyles}
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      //   placeholder={"Izaberi..."}
      noOptionsMessage={() => "Ne postoji"}
      isLoading={isLoading}
    // error={props.error}
    />
  );
});

export default SalesUnitTypeSelect;
